export function tableConfig (selectPersonClick) {
  return {
    menuType: "button",
    addBtn: false,
    menuAlign: "left",
    card: true,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: true,
    refreshBtn:true,
    menuWidth: 200,
    index: true,
    indexLabel: "序号",    
    selection:true,
    selectionWidth:45,    
    column: [
      {
        prop: 'userName',
        label: '单位员工',
        width: 100,
        bind: "userName",
        search: true,
        click: () => {
          selectPersonClick();
        },
        formatter: (row, value, label, column) => {
          let returnName = ''
          value.map((item, index) => {
            if(index == 0){
              returnName += item
            } else {
              returnName = `${returnName},${item}`
            }
          })
          return returnName
        }
      },
      {
        prop: 'vacationType',
        label: '事件类型',
        width: 120,
        bind: "vacationType",
        display: false,
        // search: true,
        // searchslot: true,
        // type: 'select',
        // dicData: [],
        // props: {
        //   label: 'dictValue',
        //   value: 'dictKey'
        // },
      },
      {
        prop: 'dayNum',
        label: '天数',
        bind: "dayNum",
        slot: true
      },{
        label: '时间',
        bind: 'timeRange',
        width: 240,
        prop: 'timeRange'
      },{
        prop: 'checkStatus',
        label: '核算',
        width: 120,
        type: 'select',
        bind: "checkStatus",
        dicData:[{
          name:'未核算',
          code:'0'
        },{
          name:'已核算',
          code:'1'
        }],
        props: {
          label: 'name',
          value: 'code'
        },
        search: true,
        dispaly: false,
        hide: true
      },{
        label: '原因',
        bind: 'vacationReason',
        prop: 'vacationReason',
        formatter: (row, value, label, column) => {
          if(!value || value == ''){
            return '/'
          }else{
            return value
          }
        }
      },
      {
        label: '核算天数',
        bind: 'checkDetails',
        prop: 'checkDetails',        
        formatter: (row, value, label, column) => {
          if(value['length'] > 0){
            let valueArray = []
            value.map(item => {
              valueArray.push(`${item['vacationTypeStr']}:${Number(item['days']).toFixed(2)}天`)
            })
            return valueArray.join(',')
          }else if(row.vacationType == '加班'){
            return `加班: ${row.vacationDay}天`
          }else{
            return '/'
          }
        }
      },{
        label: '备注',
        bind: 'checkRemark',
        prop: 'checkRemark',
        formatter: (row, value, label, column) => {
          if(!value || value == ''){
            return '/'
          }else{
            return value
          }
        }
      }
    ]    
  }
}

export function eventAddConfig (selectPersonClick) {
  return {
    // labelWidth: 160,
    gutter: 20,
    submitBtn: false,
    emptyBtn: false,
    column: [
      {
        label: '事件类型',
        prop: 'vacationType',
        type: 'select',
        // dicUrl: "/api/blade-system/dict-biz/dictionary?code=holiday_type",
        dicData: [{
          dictValue: '增加假期',
          dictKey: '增加假期'
        },{
          dictValue: '纸质请假',
          dictKey: '纸质请假'
        },{
          dictValue: '年休假结余',
          dictKey: '年休假结余'
        }],
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        span: 12,
        rules: [
          {
            required: true,
            message: '请选择事件类型',
            trigger: 'change'
          }
        ]
      },
      {
        label: '纸质请假类型',
        prop: 'vacationTypes',
        labelWidth: 110,
        display: true,
        type: 'select',
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=vacation_type",
        props: {
          label: "dictValue",
          value: "dictValue"
        },
        span: 12,
        rules: [
          {
            required: true,
            message: '请选择纸质请假类型',
            trigger: 'change'
          }
        ]
      },      
      {
        label: '天数/人',
        prop: 'vacationDay',
        span: 12,
        append:'天',
        rules: [
          {
            required: true,
            message: '请输入天数',
            trigger: 'blur'
          }
        ]
      },
      {
        label: "开始日期",
        type: 'datetime',
        prop: "vacationBeginTime",
        format:'yyyy-MM-dd HH:mm',
        valueFormat:'yyyy-MM-dd HH:mm',
        rules: [
          {
            required: true,
            message: '请选择开始时间',
            trigger: 'change'
          }
        ]
      },
      {
        label: "结束日期",
        type: 'datetime',
        prop: "vacationEndTime",
        format:'yyyy-MM-dd HH:mm',
        valueFormat:'yyyy-MM-dd HH:mm',
        rules: [
          {
            required: true,
            message: '请选择结束时间',
            trigger: 'change'
          }
        ]
      },
      {
        label: '附件上传',
        prop: 'fileUplod',
        formslot: true,
        span: 12
      },
      {
        label: '有效期',
        prop: 'validTimeRange',
        type: 'daterange',
        format:'yyyy-MM-dd',
        valueFormat:'yyyy-MM-dd',
        span: 12
      },      
      {
        label: '原因',
        type: 'textarea',
        prop: 'vacationReason',
        span: 24,
        rules: [
          {
            required: true,
            message: '请输入原因',
            trigger: 'blur'
          }
        ]        
      },
      {
        label: '单位员工',
        prop: 'unitMember',
        formslot: true,
        span: 24,
        click: () => {
          selectPersonClick();
        },
        rules: [
          {
            required: true,
            message: '请选择单位员工',
            trigger: 'change'
          }
        ]
      }
    ]
  }
}